import { render } from "./Highscores.vue?vue&type=template&id=ce5265e0"
import script from "./Highscores.vue?vue&type=script&lang=js"
export * from "./Highscores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__